/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionIntent } from './SessionIntent';
import {
    SessionIntentFromJSON,
    SessionIntentFromJSONTyped,
    SessionIntentToJSON,
    SessionIntentToJSONTyped,
} from './SessionIntent';
import type { TriageResult } from './TriageResult';
import {
    TriageResultFromJSON,
    TriageResultFromJSONTyped,
    TriageResultToJSON,
    TriageResultToJSONTyped,
} from './TriageResult';
import type { TriggerSourceFilter } from './TriggerSourceFilter';
import {
    TriggerSourceFilterFromJSON,
    TriggerSourceFilterFromJSONTyped,
    TriggerSourceFilterToJSON,
    TriggerSourceFilterToJSONTyped,
} from './TriggerSourceFilter';

/**
 * 
 * @export
 * @interface ListCapturesRequest
 */
export interface ListCapturesRequest {
    /**
     * 
     */
    includeDeviceIds?: Array<string>;
    /**
     * 
     */
    includeAllDevices?: boolean;
    /**
     * 
     */
    includeTriageResults?: Array<TriageResult>;
    /**
     * 
     */
    includeSessionIntents?: Array<SessionIntent> | null;
    /**
     * 
     */
    includeThumbnails?: boolean;
    /**
     * 
     */
    startTimestamp?: number | null;
    /**
     * 
     */
    endTimestamp?: number | null;
    /**
     * 
     */
    includeTriggerSources?: Array<TriggerSourceFilter> | null;
    /**
     * 
     */
    includeLabelIds?: Array<string> | null;
}

/**
 * Check if a given object implements the ListCapturesRequest interface.
 */
export function instanceOfListCapturesRequest(value: object): value is ListCapturesRequest {
    return true;
}

export function ListCapturesRequestFromJSON(json: any): ListCapturesRequest {
    return ListCapturesRequestFromJSONTyped(json, false);
}

export function ListCapturesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCapturesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'includeDeviceIds': json['include_device_ids'] == null ? undefined : json['include_device_ids'],
        'includeAllDevices': json['include_all_devices'] == null ? undefined : json['include_all_devices'],
        'includeTriageResults': json['include_triage_results'] == null ? undefined : ((json['include_triage_results'] as Array<any>).map(TriageResultFromJSON)),
        'includeSessionIntents': json['include_session_intents'] === undefined ? undefined : json['include_session_intents'] === null ? null : ((json['include_session_intents'] as Array<any>).map(SessionIntentFromJSON)),
        'includeThumbnails': json['include_thumbnails'] == null ? undefined : json['include_thumbnails'],
        'startTimestamp': json['start_timestamp'] === undefined ? undefined : json['start_timestamp'] === null ? null : json['start_timestamp'],
        'endTimestamp': json['end_timestamp'] === undefined ? undefined : json['end_timestamp'] === null ? null : json['end_timestamp'],
        'includeTriggerSources': json['include_trigger_sources'] === undefined ? undefined : json['include_trigger_sources'] === null ? null : ((json['include_trigger_sources'] as Array<any>).map(TriggerSourceFilterFromJSON)),
        'includeLabelIds': json['include_label_ids'] === undefined ? undefined : json['include_label_ids'] === null ? null : json['include_label_ids'],
    };
}

export function ListCapturesRequestToJSON(json: any): ListCapturesRequest {
    return ListCapturesRequestToJSONTyped(json, false);
}

export function ListCapturesRequestToJSONTyped(value?: ListCapturesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'include_device_ids': value['includeDeviceIds'],
        'include_all_devices': value['includeAllDevices'],
        'include_triage_results': value['includeTriageResults'] == null ? undefined : ((value['includeTriageResults'] as Array<any>).map(TriageResultToJSON)),
        'include_session_intents': value['includeSessionIntents'] == null ? undefined : ((value['includeSessionIntents'] as Array<any>).map(SessionIntentToJSON)),
        'include_thumbnails': value['includeThumbnails'],
        'start_timestamp': value['startTimestamp'],
        'end_timestamp': value['endTimestamp'],
        'include_trigger_sources': value['includeTriggerSources'] == null ? undefined : ((value['includeTriggerSources'] as Array<any>).map(TriggerSourceFilterToJSON)),
        'include_label_ids': value['includeLabelIds'],
    };
}

